module.exports = __webpack_public_path__ + "img/02-AppMyTip-01.a77717ad.png";